// /pages/settingsPage.jsx
import React, { useEffect } from "react";
import { AppBar, Tabs, Tab, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSearchParams } from "react-router-dom";
import SettingsAccount from "./components/settingsAccount";
import Header from "../components/header";
import LegalProfessionals from "../professionals/professionals";
import FinanceDashboard from "../payment/financeDashboard";
import SettingsIntake from "./components/settingsIntake";
import SettingsLawFirmProfile from "./components/settingsLawFirmProfile";
import SettingsAppointmentTypes from "./components/settingsAppointmentTypes";
import SettingsLocations from "./components/settingsLocations";
import SettingsHours from "./components/settingsHours";
import Pricing from "./components/pricing";
import "./settingsPage.css";

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: "1px solid #E5E7EB",
  minHeight: 48,
  "& .MuiTabs-indicator": { display: "none" },
}));

const StyledTab = styled((props) => <Tab disableRipple {...props} />)({
  textTransform: "none",
  minWidth: "auto",
  padding: "12px 16px",
  fontSize: 16,
  fontWeight: 500,
  fontFamily: "Poppins",
  color: "#333333",
  "&.Mui-selected": {
    fontSize: 17,
    fontWeight: 550,
    color: "#333333",
    padding: "12px 16px",
    fontFamily: "Poppins",
  },
});

const pages = [
  { key: "account", label: "Account", component: <SettingsAccount /> },
  { key: "legal-professional", label: "Legal professional", component: <LegalProfessionals /> },
  { key: "law-firm-profile", label: "Law firm profile", component: <SettingsLawFirmProfile /> },
  { key: "intake", label: "Intake", component: <SettingsIntake /> },
  { key: "appointment-type", label: "Appointment type", component: <SettingsAppointmentTypes /> },
  { key: "locations", label: "Locations", component: <SettingsLocations /> },
  { key: "billing", label: "Billing", component: <FinanceDashboard /> },
  { key: "pricing", label: "Pricing", component: <Pricing /> },
  { key: "booking-hours", label: "Booking hours", component: <SettingsHours /> },
  // { key: "integrations", label: "Integrations", component: <></> },
  // { key: "your-website", label: "Your website", component: <></> },
  // { key: "terms-policy", label: "Terms & policy", component: <></> },
];

export default function SettingsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabKey = searchParams.get("tab") || pages[0].key;
  const currentTab = pages.findIndex((p) => p.key === tabKey);

  useEffect(() => {
    // If the tabKey is invalid, reset to the first tab
    if (currentTab === -1) {
      setSearchParams({ tab: pages[0].key });
    }
    // eslint-disable-next-line
  }, [tabKey]);

  const handleTabChange = (_, newIndex) => {
    setSearchParams({ tab: pages[newIndex].key });
  };

  return (
    <div className="settings-account-page">
      <Header />

      <AppBar
        position="fixed"
        color="inherit"
        elevation={0}
        style={{ backgroundColor: "white", top: "64px", zIndex: 1200 }}
      >
        <StyledTabs
          value={currentTab === -1 ? 0 : currentTab}
          onChange={handleTabChange}
          variant="standard"
          centered
          textColor="inherit"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "8px",
            width: "100%",
          }}
        >
          {pages.map((p) => (
            <StyledTab key={p.key} label={p.label} />
          ))}
        </StyledTabs>
      </AppBar>

      <Box className="settings-account-content">
        {pages[currentTab === -1 ? 0 : currentTab].component}
      </Box>
    </div>
  );
}
